// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ShareAndroidFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M73.383 59.28c-4.588 0-8.664 2.22-11.243 5.632L36.392 51.036c.202-.948.314-1.928.314-2.936 0-1.07-.131-2.11-.36-3.112l25.798-13.902c2.579 3.412 6.652 5.635 11.239 5.635 7.782 0 14.117-6.35 14.117-14.118C87.5 14.835 81.165 8.5 73.383 8.5c-7.769 0-14.104 6.335-14.104 14.103 0 .794.083 1.568.21 2.326l-25.36 15.077c-2.557-3.626-6.768-6.01-11.526-6.01C14.835 33.997 8.5 40.334 8.5 48.1c0 7.768 6.335 14.103 14.103 14.103 4.821 0 9.087-2.443 11.632-6.151l25.254 15.007c-.128.762-.21 1.54-.21 2.338 0 7.768 6.335 14.103 14.104 14.103 7.782 0 14.117-6.335 14.117-14.102 0-7.784-6.335-14.119-14.117-14.119Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default ShareAndroidFilled;
